import { createContext, useContext } from 'react';

import { ActivityFragment } from '@spotify/confidence-graphql';

export interface ReactionSummary {
  commentCount: number;
}

export interface ActivityFeedItemContextValue {
  activity: Pick<ActivityFragment, 'name' | 'activityTime' | 'actor'>;
  reactions: ReactionSummary;
  // UI state only - no data!
  showComments: boolean;
  setShowComments: (show: boolean) => void;
}

export const ActivityFeedItemContext =
  createContext<ActivityFeedItemContextValue | null>(null);

export const useActivityFeedItemContext = () => {
  const context = useContext(ActivityFeedItemContext);
  if (!context) {
    throw new Error(
      'useActivityFeedItemContext must be used within ActivityFeedItem.Root',
    );
  }
  return context;
};
